import React from 'react';

import { useChooseFiles } from '@gogame/hooks-ts';

import {
  useDeleteMasterCampaign,
  useUploadMasterCampaign,
} from 'scenes/Influencers/MasterCampaigns/data/mutations';
import { resetFileInput } from 'scenes/Influencers/utils/form';

import Actions from './Actions';

const ActionsWrapper = ({ onEdit, onDuplicate, onDelete, data }) => {
  const chooseFiles = useChooseFiles({ accept: '.csv' });
  const [uploadMasterCampaign] = useUploadMasterCampaign();
  const [deleteMasterCampaign] = useDeleteMasterCampaign();

  const handleImport = async (e) => {
    const [file] = await chooseFiles();
    const fileInFormData = new FormData();
    fileInFormData.append(
      'file',
      new Blob([file], { type: 'application/octet-stream' }),
      file.name
    );

    resetFileInput(e);
    await uploadMasterCampaign({
      fileInFormData,
      fileName: file.name,
      masterCampaignId: data.id,
      masterCampaignName: data.name,
    });
  };

  const handleEdit = (e) => {
    onEdit(e, { id: data.id });
  };

  const handleDuplicate = (e) => onDuplicate(e, { id: data.id });

  const handleDelete = async () => {
    await deleteMasterCampaign({ id: data.id, name: data.name });
    onDelete?.();
  };

  return (
    <Actions
      actions={data?.actions}
      onImport={handleImport}
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      onDelete={handleDelete}
    />
  );
};

export default ActionsWrapper;
